var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flags-overlay"},_vm._l((_vm.flags),function(flag,i){return _c('flag',{key:flag.id,ref:"flag",refInFor:true,attrs:{"x":flag.x,"y":flag.y}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2355620a","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/flags-overlay.vue
// module id = 458
// module chunks = 0